import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page58() {
  useEffect(() => {
    document.title = "Маяк — Страница 57"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page56" />
        <ForwardLink href="/page58" />
      </div>

      <p style={{ textAlign: "right" }}>57.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Твоя проблема в том, что ты ешь<br/>
        траву без зубов.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Что ты сказал?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        У твоих морских приятелей зубы<br/>
        выпали--
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        К чему ты клонишь, Уинслоу?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Просто... просто, это кажется очень<br/>
        затруднительным, есть траву без зубов.<br/>
        Козы, овцы и коровы. Ну<br/>
        вот, у них у всех есть зубы,<br/>
        так?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Сказать, как есть траву без<br/>
        зубов?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Сделайте одолжение.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Вырываешь ее и глотаешь.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Вырываешь и глотаешь.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Вырываешь и--
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Не знаю насчет этого.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Ты не знаешь?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я не знаю.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Что?
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Что?
      </p>
      <p style={{ textAlign: "right" }}>57.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page56" />
        <ForwardLink href="/page58" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710628855/the-lighthouse-script/fewbf2jkh4pfzpghsl7x.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page58;
